import React  from 'react';
import "./style/legalstyle.css"
const PrivacyPolicy = () => {
    return (
        <>
            <div class="privacyPolicyWrapper">
    <h1 class="policyHeading">Privacy Policy</h1>
    <div class="detailPolicyes">
      <h4>Effective date: August 1, 2022 Last updated on August 1, 2022</h4>
      <h2>GENERAL</h2>
      <ul>
        <li>
          This Mobile Application with the name of DEAKS (App/DEAKS") is operated
          by Deaks private limited('/We/Our/Us) We are committed to protecting and
          respecting your privacy. We do collect your personal information and
          process your personal data in accordance with the PERSONAL DATA
          PROTECTION (AMENDMENT) ACT 2020 of Singapore Law. Which relate the
          processing of personal data: Please read the following carefully to
          understand our views and practices regarding your personal data
        </li>
        <li>
          Downloading, accessing or otherwise using the App indicates that you
          have read this Privacy Policy and consent to its terms. If you do not
          consent to the terms of this Privacy Policy, do not proceed to download,
          access, or otherwise use the App.
        </li>
        <li>
          We collect your personal information in order to provide and continually
          improve our products and services.
        </li>
        <li>
          Our privacy policy is subject to change at any time without notice. To
          make sure you are aware of any changes, please review this policy
          periodically. The last updated date can found at the beginningof this
          policy.
        </li>
        <li>
          All partner firms and any third-party working with or for Us, and who
          have access to personal information, will be expected to read and comply
          with this policy.
        </li>
      </ul>
  
  
      <h2>HOW WE COLLECT THE INFORMATION</h2>
      <ul>
        <li>
          From you directly and through this App: We may collect information through the App when you
          visit The data we collect depends on the context of your interactions with our App
        </li>
  
        <h2>INFORMATION WE COLLECT</h2>
        <li>We collect information primarily to provide better services to all of our customers.</li>
        <li>
          We collect the following information from you when you use or signup on our App:<br></br>
          Name, contact number and NRIC number (Residential status ID) and DOB
        </li>
        <li>
          When you visit our App, some information is automatically collected. This may include information such as the
          type of
          mobile device, Operating System (OS) running on your device, Internet Protocol (IP) address, unique user ID,
          access
          times, device type, and language. We also collect information about how you use Our products or services.
        </li>
        <li>
          We automatically collect purchase or content use history, which we sometimes aggregate with similar information
          from
          other customers to create features such as Best Seller, Top Rated, etc... e. The information about your usage of
          the
          App, including crash logs and usage statistics.
        </li>
        <li>
          We will retain your information as long as we require this to provide you with the goods and services and for
          such
          period as mandated by the concerned laws.
        </li>
        <li>
          If you opt to receive marketing correspondence from us, subscribe to our mailing list or newsletters, enter into
          any of
          our competitions or provide us with your details at networking events,we may use your personal data for our
          legitimate interests in order to provide you with details about our goods, services, business updates and
          events.
        </li>
      </ul>
  
      <h2>INFORMATION WE COLLECT</h2>
      <ul>
        <li>We use the information we collect primarily to provide, maintain, protect, and improve our current products
          and services</li>
        <li>We use the information to:</li>
        <div>
          <ul>
            <li>improve our services, App and how we operate our businesses,</li>
            <li>Understand and enhance your experience using our App, products and services;</li>
            <li>Personalize our products or services and make recommendations;</li>
            <li>Provide and deliver products and services you request;</li>
            <li>Process, manage, complete, and account for transactions;</li>
            <li>Provide customer support and respond to your requests, comments, and inquiries;</li>
            <li>Create and manage the online accounts you manage on our App:</li>
            <li>Send you related information, including confirmations, invoices, technical notices, updates,security
              alerts and support and administrative messages</li>
            <li>Communicate with you about promotions, upcoming events and news about products and services</li>
            <li>We may process your personal information without your knowledge or consent where required by applicable
              law or regulation for the purposes of verification of identity or for prevention, detection or
              investigation, including of cyber incidents, prosecution and punishment of offences</li>
            <li>Protect, investigate and deter against fraudulent, unauthorized or illegal activity</li>
          </ul>
        </div>
      </ul>
  
  
      <h2>DATA TRANSFER</h2>
      <ul>
        <li>Information about our user is an important part of our business and we take due care</li>
        <li>we only share the data with respective officers who is the in charge of personal identification matter at
          premise entry.</li>
        <li>We wont employ other companies and individuals to perform functions on our behalf.</li>
        <li>No third-party service providers involved to access to personal information and as permitted by applicable
          data
          protection laws.</li>
      </ul>
  
  
      <h2>DATA SECURITY</h2>
      <ul>
        <li>We take due care to protect customer data. Technical measures are in place to preventunauthorized or unlawful
          access to
          data and against accidental loss or destruction of, or damage to the data. The employees who are dealing with
          the data
          have been trained to protect the data from any illegal or unauthorized usage.
        </li>
        <li>We maintain physical, electronic, and procedural safeguards in connection with the collection, storage, and
          disclosure
          of personal customer information.</li>
        <li>We take reasonable steps to help protect your personal information in an effort to prevent the loss misuse,
          and
          unauthorized access, disclosure alteration and destruction. It is our responsibility to protect your user names
          and
          passwords to help prevent anyone from accessing or abusing your accounts and services. You should not use or
          reuse the
          same passwords you use with otheraccounts as your password for our services.
        </li>
        <li>It is important for you to protect against unauthorized access to your password and your devices,and
          applications. Be
          sure to sign off when you finish using a non-personal device.
          Information you provide to us is shared on our secure servers.</li>
      </ul>
  
  
      <h2>LINKS TO THIRD PARTY SITE/APPS</h2>
      <ul>
        <li>Our App may, from time to time, contain links to and from other Apps/Websites of third parties. Please note
          that if you
          follow a link to any of these Apps/Websites, such Apps/Websites will apply different terms to the collection and
          privacy
          of your personal data and we do not accept any responsibility or liability for these policies When you leave our
          Site,
          we encourage you to read the privacy policy of every App/Website you visit.</li>
      </ul>
  
  
      <h2>SHARING OF PERSONAL INFORMATION</h2>
      <ul>
        <li>We do not share your personal data with third parties without your prior consent other than
          With third parties who work on our behalf provided such third parties adhere to the data Protection. For the
          purpose of a business deal (or negotiation of a business deal) involving the sale or transfer of all
          or a part of our business or assets (business deals may include, for example, any merger, financing,
          acquisition, divestiture or bankruptcy transaction or proceeding)</li>
      </ul>
  
  
      <h2>CHILDREN</h2>
      <ul>
        <li>If you are under the age of 16 or the age of majority in the jurisdiction of Singapore, you may only use Our
          App with
          the consent of your parent or legal guardian. In any case, We will not be liable for any cause of action that
          arose due
          to non-compliance with this section.</li>
      </ul>
  
  
      <h2>CHANGES TO THIS POLICY</h2>
      <ul>
        <li>We may change this policy from time to time. If we make any changes to this policy, we will change
          the "Last Updated date above. You agree that your continued use of our services after such changes
          have been published to our services will constitute your acceptance of such revised policy.
          If you have any concern about privacy or grievances with Us, please contact us with a thorough description and
          we will
          try to resolve the issue for you.
        </li>
      </ul>
    </div>
    <p class="policyContact">Please contact or write to us if there any concern in the privacy / data protection policy
      statement.
      Write to us : deaks@deaksgroup.com or call us on +65 91828031
      Address : 132A casuarina road, Sembawang hills estate, 579520</p>
  </div>
        </>
    )
}

export default PrivacyPolicy;